import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=42e92c20&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=42e92c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e92c20",
  null
  
)

export default component.exports